import { api } from "@/app/api";

export const fetchJourneyOptions = async () =>
  (await api.get("/eligibility/journey-options")).data.options;

export const fetchLocationOptions = async (location) =>
  (await api.post("/eligibility/location-options", { answers: { location } })).data;

export const identifyInstitution = async (payload) =>
  (await api.post("/eligibility/identify-institution", payload)).data;

export const saveJourney = async (payload) =>
  (await api.post("/journey/save", payload)).data;

export const resumeJourney = async (token) =>
  (await api.get(`/journey/resume/${token}`)).data;

export const previewNavigator = async (answers) =>
  (await api.post("/eligibility/navigator-preview", { answers })).data;

export const assessEducationAnswers = async (answers) =>
  (await api.post("/eligibility/assess-education", { answers })).data;

export const fetchOpportunity = async (slug) =>
  (await api.get(`/opportunities/${slug}`)).data;

export const fetchIndividualProfile = async () =>
  (await api.get("/individual/profile")).data.profile;

export const fetchSavedEligibilityAssessment = async (assessmentId) =>
  (await api.get(`/individual/eligibility-assessments/${assessmentId}`)).data;

export const runOpportunityEligibility = async (slug, { answers, useProfile, persist }) =>
  (await api.post(`/opportunities/${slug}/eligibility`, { answers, use_profile: useProfile, persist })).data;

export const saveEligibilityAssessment = async (payload) =>
  (await api.post("/individual/eligibility-assessments", payload)).data;

export const continueEligibilityLater = async (assessmentId) =>
  (await api.post(`/individual/eligibility-assessments/${assessmentId}/continue-later`)).data;

export const startEligibilityVerification = async (assessmentId) =>
  (await api.post(`/individual/eligibility-assessments/${assessmentId}/start-verification`)).data;
